import axios from "axios";
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Dropdown APIs
//TODO: Brand APIs
//  Brand
export const brandDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}brand-dd`, data, headers);
};
//TODO: Category APIs
//  Category
export const categoryDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}category-dd`, data, headers);
};
export const groupDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}test-category-list`, data, headers);
};
export const categoryTestDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}testcategory-list-dd`, data, headers);
};
export const getDeliveryBoy = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}pharmacy-boy-list`, data, headers);
};
export const labTestDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}labs-packages-tests`, data, headers);
};
export const packageDD = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}package-list-dd-lab`, data, headers);
};
export const subCategoryDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}sub-category-list-dd`, data, headers);
};
export const generateFileAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}generate-excel`, data, headers);
};
export const subMultipleCategoryDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}multiplecategory-dd`, data, headers);
};
export const getSubgorupDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}lab-sub-group-dropdown-list`, data, headers);
};
export const getSubgorupDD = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}admin-package-Subgroupdd`, data, headers);
};
export const categoryPackageDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}package-dd`, data, headers);
};
export const categoryPackageAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}lab-package-dd`, data, headers);
};
export const testDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}test-list-dd`, data, headers);
};
export const testListAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}lab-test-dropdown-list`, data, headers);
};
export const testListDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}package-subgroups-test-list-dd`, data, headers);
};

//TODO: Product Type APIs
//  Product Type
export const productTypeDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}product-type-dd`, data, headers);
};
//TODO: Specialization APIs
//  Specialization
export const specializationDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}specialization-dd`, data, headers);
};
//TODO: Ingredients APIs
//  Ingredients
export const ingredientsDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}ingredients-dd`, data, headers);
};
export const assignBoyAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}assign-delivery`, data, headers);
};
//TODO: Disease APIs
//  Disease
export const diseaseDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}disease-dd`, data, headers);
};
//TODO: Unit APIs
//  Unit
export const unitDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}unit-dd`, data, headers);
};
//TODO: Product APIs For Coupon Create
//  Product
export const productDDAPI = async (data) => {
  const headers = createHeaders(); 
  return await axios.get(`${BASE_URL}product-dd`, { params: data, headers: headers?.headers });
};
//TODO: State APIs For Coupon Create
//  State
export const stateDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}state-dd`, data, headers );
};
//TODO: District APIs For Pharmacy Create 
//  District
export const districtDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}district-list-dd`, data, headers );
};

//TODO: Product APIs
//  Product Create
export const createProductAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-product`, data,headers);
}
//  Product Update
export const updateProductAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-product`, data,headers);
};
//  Product List
export const listProductAPI = async () => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}list-product`, headers);
};
//  Qualification List
export const listQualificationDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}qualification-list-dd`,{}, headers);
};
//  Specification List
export const listSpecificationDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}specialization-list-dd`,data, headers);
};
//  Store List
export const listStoreDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}store-list-dd`,data, headers);
};
export const stepOnePharmacyDetails = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-pharmacy-detail`,data, headers);
};
export const stepTwoPharmacyDetails = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-operational-detail`,data, headers);
};
export const stepthreePharmacyDetails = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-address-detail`,data, headers);
};
export const stepFourPharmacyDetails = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-bank-detail`,data, headers);
};
export const listHospitalAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-list`,data, headers);
};
export const listHospitalDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-list-dd`,data, headers);
};
//  State List
export const listStateDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}state-list-dd`,data, headers);
};

export const departmentCategoryDropDown = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}department-category-dropdown`,data, headers);
};
